import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = {};

export function useRefData(names) {
  const [data, setData] = useState(() => Object.fromEntries(names.map((n) => [n, cache[n] || []])));
  const key = names.join(",");
  useEffect(() => {
    let alive = true;
    Promise.all(
      names.map((n) => api.get(`/e/${n}`).then((r) => [n, r.data]).catch(() => [n, []]))
    ).then((rows) => {
      if (!alive) return;
      rows.forEach(([n, d]) => (cache[n] = d));
      setData(Object.fromEntries(rows));
    });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return data;
}

export const invalidateRef = (name) => delete cache[name];
